import { render, staticRenderFns } from "./ModalTransferNow.vue?vue&type=template&id=55ab3108&"
import script from "./ModalTransferNow.vue?vue&type=script&lang=js&"
export * from "./ModalTransferNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports